import ApplicationHeader from './ApplicationHeader';

export default ApplicationHeader;
